import styled from 'styled-components';
import { Box } from '@rsos/base-components';

export const BannerWrapper = styled(Box).attrs({
  my: 12,
  mx: 16,
  align: 'center',
  px: 20,
  py: 12,
  color: 'background',
  horizontal: true,
  borderRadius: 5,
  flow: 12,
})``;
